import { AxiosResponse } from 'axios';

export function parseFilename(response: AxiosResponse<Blob>): string {
  const disposition = response.headers['content-disposition'];
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(disposition ?? '');

  if (!!matches && matches[1]) {
    const raw = matches[1].replace(/['"]/g, '');
    return raw.replace(/^.*[\\/]/, '') || 'unknown';
  }

  return 'unknown';
}

export const saveBlob = (data: Blob, fileName: string) => {
  const blobURL = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = blobURL;
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(blobURL);
};

export const downloadBlob = async (response: AxiosResponse<Blob>, overrideFileName?: string) => {
  saveBlob(new Blob([response.data]), overrideFileName ?? parseFilename(response));
};
